import wating from '@imgs/rechange_wating.png'
import success from '@imgs/rechange_success.png'
import fail from '@imgs/rechange_fail.png'

export default {
  data: () => ({
    wating,
    success,
    fail,
  }),
}